import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { getFactorCategoryId, getFactorCategoryName } from "./selectors"
import { getOptions, getSelectedOption, getFilteredData, getCategoryItemsSubset } from "./selectors/data"
import { getFileName } from "./selectors/file"
import { getFirstForecastDate, getCurrentForecast, getAdjustedEndDate, getAdjustedSelectedDate, getForecast } from "./selectors/forecast"
import { getAllCategoryItems } from "./selectors/items"
import { convertPositionSetType } from "helpers/compositeSecurities"
import { VIEW_TYPES } from "helpers/base"

export default createModule({
  view,
  required: ["account", "positionSetId", "positionSetType", "modelId"],
  data: [{
    resource: "compositeDailyForecast",
    as: null,
    url: ({ positionSetId, positionSetType, modelId, viewType, startDate, endDate, baseSignature, baseStartDate, forecastId, segment }) => {
      let from = startDate
      const to = endDate

      if (viewType === VIEW_TYPES.ACTIVE && from < baseStartDate) {
        from = baseStartDate
      }

      return {
        id: `compositeDailyForecast-${modelId}${positionSetId}${positionSetType}${from}${to}${viewType}${baseSignature}${forecastId}${JSON.stringify(segment)}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $from: Date!, $to: Date!, $forecastId: ShortId!) {
          model (id: $modelId) {
            simulation(positionSet: $positionSet, from: $from, to: $to, interval: AUTO) {
              dailyForecast (forecastId: $forecastId) {
                date
                expectedReturn
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            type: convertPositionSetType(positionSetType),
            id: positionSetId,
            segment,
          },
          from,
          to,
          forecastId,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    firstDate: getFirstForecastDate(state, props),
    data: getFilteredData(state, props),
    items: getCategoryItemsSubset(state, props),
    allCategoryItems: getAllCategoryItems(state, props),
    options: getOptions(state, props),
    fileName: getFileName(state, props),
    factorCategoryId: getFactorCategoryId(state, props),
    factorCategoryName: getFactorCategoryName(state, props),
    selectedOption: getSelectedOption(state, props),
    forecast: getCurrentForecast(state, props),
    dailyForecastData: getForecast(state),
    endDate: getAdjustedEndDate(state, props),
    selectedDate: getAdjustedSelectedDate(state, props),
  }),
  actions: {
    ...Creators,
    addNotification: notificationsCreators.add,
  },
})
